
export default function Hero() {
  return (
    <section id="top" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.readdy.ai/image/6095022e0c468d9535f3b012298ccfc9/8dc8783adfa5e7b650b75f024ae1b4ae.jpeg"
          alt="エアコンクリーニング"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-cyan-500/40 via-cyan-400/30 to-white/90"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-2xl mx-auto px-4 py-20 text-center">
        {/* Logo */}
        <div className="mb-8 flex justify-center">
          <img
            src="https://static.readdy.ai/image/6095022e0c468d9535f3b012298ccfc9/ef758113f5eb1527424f84f893360d0d.jpeg"
            alt="エアクリーンサービス江田島"
            className="w-48 h-auto"
          />
        </div>

        {/* Main Heading */}
        <h1 className="text-2xl md:text-5xl font-bold text-white mb-4 leading-tight">
          エアクリーンサービス
        </h1>
        <p className="text-lg md:text-2xl font-medium text-white mb-6 inline-block px-4 py-1 rounded-full bg-black/20 backdrop-blur-sm" style={{ textShadow: '0 1px 3px rgba(0,0,0,0.3)' }}>
          2026年4月 独立開業
        </p>

        {/* Sub Copy */}
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 mb-6 md:mb-10 shadow-lg">
          <p className="text-lg md:text-xl text-gray-800 font-bold mb-1">
            江田島市・呉市で地域密着対応
          </p>
          <p className="text-sm md:text-base text-gray-700 font-normal leading-relaxed">
            江田島市在住・呉市出身（焼山町）
          </p>
          <p className="text-xs md:text-sm text-gray-500 font-normal leading-relaxed mt-1">
            女性スタッフの同行も可（ご希望制）
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="space-y-4 pt-2 pb-4 md:pt-0 md:pb-0">
          {/* メインCTA: LINE */}
          <a
            href="https://lin.ee/ltlhjZa"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full bg-[#06C755] hover:bg-[#05b34c] text-white font-bold py-5 px-6 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <div className="flex items-center justify-center gap-3">
              <i className="ri-line-fill text-2xl"></i>
              <div className="text-left">
                <div className="text-lg">LINEで質問する</div>
                <div className="text-sm opacity-90">写真を送ってのご相談もOK</div>
              </div>
            </div>
          </a>

          {/* サブCTA: Instagram・電話 */}
          <div className="flex gap-3 mt-3">
            <a
              href="https://www.instagram.com/air_clean.etajima/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 bg-white/80 backdrop-blur-sm hover:bg-white text-gray-700 font-medium py-3 px-4 rounded-full transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer border border-gray-200"
            >
              <div className="flex items-center justify-center gap-2">
                <i className="ri-instagram-fill text-xl text-pink-500"></i>
                <span className="text-sm">Instagram</span>
              </div>
            </a>

            <a
              href="tel:080-1752-6324"
              className="flex-1 bg-white/80 backdrop-blur-sm hover:bg-white text-gray-700 font-medium py-3 px-4 rounded-full transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer border border-gray-200"
            >
              <div className="flex items-center justify-center gap-2">
                <i className="ri-phone-fill text-xl text-gray-600"></i>
                <span className="text-sm">電話する</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
